import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import HOIconSVG from '../assets/images/HOIconSVG';
import { SIGN_OUT_ENDPOINT } from '../constants/AppAPIConstants';
import { SERVICE_NAME } from '../constants/AppConstants';
import { LANDING_URL, SIGN_IN_URL } from '../constants/AppUrlConstants';
import Auth from '../utils/Auth';
import Nav from './Nav';

import '../assets/css/Header.scss';

const Header = () => {
  const navigate = useNavigate();
  const isAuthenticated = !!Auth.isAuthorized();

  const handleSignOut = async () => {
    try {
      const response = await axios.post(SIGN_OUT_ENDPOINT, {}, {
        headers: { Authorization: `Bearer ${Auth.retrieveUserAccess()?.refreshToken}` }
      });
      if (response.status === 200) {
        Auth.logout();
        navigate(SIGN_IN_URL, { replace: true, state: { suppressBack: true } });
      }
    } catch {
      Auth.logout();
      navigate(SIGN_IN_URL, { replace: true, state: { suppressBack: true } });
    }
  };

  return (
    <header className="hods-header" data-module="hods-header">
      <div className="container hods-width-container">
        <div className="hods-header__main">
          <HOIconSVG />
          <div className="hods-header__title">
            <Link
              to={LANDING_URL}
              className="hods-header__link hods-header__link--service-name"
            >
              {SERVICE_NAME}
            </Link>
          </div>
          {isAuthenticated && (
            <div className="hods-header__account-menu">
              <ul>
                <li>
                  <button
                    type="button"
                    className="hods-button--text hods-header__link"
                    onClick={handleSignOut}
                  >
                    Sign out
                  </button>
                </li>
              </ul>
            </div>
          )}
        </div>
        {isAuthenticated && (
          <Nav />
        )}
      </div>
    </header>
  );
};

export default Header;
